import React from 'react';
import { Redirect } from 'react-router-dom';
import {connect} from 'react-redux';
import jwt_decode from 'jwt-decode';
import Home from '../components/Home';
import AdminHome from '../components/AdminHome';

const HomeContainer = ({main, order}) => {
    const sessionStorageToken = sessionStorage.getItem('rtvcrespoToken');
    let decodedToken = null;
    let user = null;
    if(sessionStorageToken){
        decodedToken = jwt_decode(sessionStorageToken);
        user = decodedToken.user;
    }
    

    if(!sessionStorageToken){
        return <Redirect to='/login'/>
    }

    return (
        (user.role) !== 'admin') ? 
                (<Home main={main} order={order}/>)
            :
                (<AdminHome />
    );
};

const mapStateToProps = (state) => ({
    main: state.main,
    order: state.order
});

export default connect(mapStateToProps)(HomeContainer);


// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js